require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-4-tips-for-a-more-merry-stress-free-holiday-shopping-season.json") })
        }
      }, "path---es-articles-4-tips-for-a-more-merry-stress-free-holiday-shopping-season");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-4-tips-for-a-more-merry-stress-free-holiday-shopping-season!./.cache/json/es-articles-4-tips-for-a-more-merry-stress-free-holiday-shopping-season.json
// module id = 2057
// module chunks = 231608221292675